module.exports = {
      id: "premium-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#premium",
      toString: function () {
        return this.url;
      }
    }